/**
 * Global utilities
 */
import Vue from 'vue'
import uiGlobals from './ui_globals'

export function viewportSize () {
  return {
    w: Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
    h: Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
  }
}

export const isMobileViewport = window && window.matchMedia(`(max-width: ${uiGlobals['$screen-xs-max']})`).matches

/**
 * Base URL for the User Site
 */
export const ASPEN_BASE_URL = window.location.protocol + '//' + window.location.host.toLowerCase().replace('www', 'user')

const eventBuses = {}
export function eventBus (id = 'global') {
  return eventBuses[id] || (eventBuses[id] = new Vue())
}

export function geoName (geo) {
  let name = 'this area'
  if (geo && geo.type !== 'GeoBounds') {
    if (geo.slug === 'united-states-of-america') {
      name = 'the USA'
    } else if (geo.name) {
      name = geo.name
    }
  }
  return name
}

export function cloneGeo (geo) {
  if (!geo) return geo

  return {
    id: geo.id,
    type: geo.type,
    slug: geo.slug,
    name: geo.name,
    is_available: geo.is_available
  }
}



// WEBPACK FOOTER //
// ./frontend/src/utils.js